import React from "react";

/**
 * Flatten a provider pyramid into one component.
 *
 *   const Providers = composeProviders(A, B, C);
 *   // equivalent to <A><B><C>{children}</C></B></A>
 *
 * Later providers in the list are nested deeper, so providers on the
 * right can read context from providers on the left.
 */
export const composeProviders = (...providers) => {
  const Composed = ({ children }) =>
    providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children,
    );
  Composed.displayName = `ComposeProviders(${providers
    .map((p) => p.displayName ?? p.name ?? "Anonymous")
    .join(", ")})`;
  return Composed;
};
